
import styles from "./TestContent.module.scss";
import { useTranslation } from 'react-i18next'
import { Button, Layout } from "components";
import { useEffect, useState } from "react";

import closeicon from 'assets/icons/lock.png'
import openicon from 'assets/icons/unlock.png'
import Notification from "utils/Notifications";
import { getTestDetailData, OnOffTestDetailData, GetURLTest } from "service/TestService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { useLocation, useNavigate } from 'react-router-dom'
import TestForm from 'components/Forms/TestForm/TestForm';
import PartWork from './PartWork/PartWork';
import PartWorkReport from './PartWorkReport/PartWorkReport';

import TestCaseUser from './TestCaseUser/TestCaseUser';
import TestCaseUserLose from './TestCaseUser/TestCaseUserLose';

const TestContent = () => {
  const { t } = useTranslation('common')

  const [showForm, setShowForm] = useState(false);
  const [showUserInfo, setShowUserInfoForm] = useState(false);
  const [showUserInfoLose, setShowUserInfoFormLose] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const handleShowForm = (check) => {
    setShowForm(check);
    setShowUserInfoForm(false);
    setShowUserInfoFormLose(false);
    setShowReport(false);
  };

  const handleShowUserInfo = (check) => {
    setShowUserInfoForm(check);
    setShowForm(false);
    setShowUserInfoFormLose(false);
    setShowReport(false);
  };


  const handleShowUserInfoLose = (check) => {
    setShowUserInfoFormLose(check);
    setShowUserInfoForm(false);
    setShowForm(false);
    setShowReport(false);
  };

  const handleShowReport = (check) => {
    setShowReport(check);
    setShowUserInfoFormLose(false);
    setShowUserInfoForm(false);
    setShowForm(false);
  };
  
  const navigate = useNavigate()
  const location = useLocation()
  const [render, setRender] = useState(false)
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const getData = async (id) => {
    try {
      let response = await getTestDetailData(id, data);
      setData(response.data);

    } catch (error) {
    }
  };

  useEffect(() => {
    if (location.state && location.state.usedId) {

      const usedId = location.state.usedId;

      setId(usedId)

      getData(usedId);

      setRender(false);
    } else {

      navigate("/tests");
    }


  }, [render, location.pathname, location.state, showForm]);


  const handleSubmitURL = async (event) => {
    event.preventDefault();

    let testsinfo = await GetURLTest(id);
    setNotify({
      isOpen: true,
      message: "Ссылка на тест успешно получена!",
      type: "success",
    });
    setRender(true)

  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let testsinfo = await OnOffTestDetailData(id);
    setNotify({
      isOpen: true,
      message: "Статус успешно обновлен!",
      type: "success",
    });
    setRender(true)

  };

  const partWorkTests = data?.part_worktest || [];
  const partUserTests = (data?.employee_part_worktest || [])
    .filter(item => item.status_info === 'Завершен');
  const partUserTestsLose = (data?.employee_part_worktest || [])
    .filter(item => item.status_info === 'Начат');
  return (
    <Layout>
      <div className={styles["test-block"]}>
        <div className={styles["test-app"]}>

          <h2>{data.title}</h2>
          <Button
            className={styles.open_btn}
            onClick={() => navigate('/tests/')}
          >
            Вернуться
          </Button>
        </div>
        <div className={styles.test_content_block}>
          <div className={styles.test_content_body}>
            <p> Вопросов: {data.part_worktest ? data?.part_worktest?.filter(item => item.type_answer !== "infoText").length || 0 : 0}
            </p>
            {showForm ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowForm(false)}>
              Закрыть
            </button></> : <>
              <button className={styles.open_btn_sub_black} onClick={() => handleShowForm(true)}>
                Добавить
              </button>
            </>}

          </div>
          <div className={styles.test_content_header}>

            <p className={styles.title_test}>
              Статус теста:
              <img
                src={data.activate ? openicon : closeicon}
                className={styles.img}
                alt={data.activate ? "Открыт" : "Закрыт"}
              />
              {data.activate ? "Открыт" : "Закрыт"}
            </p>
            <button
              className={data.activate ? styles.close_btn_sub : styles.open_btn_sub}
              onClick={handleSubmit}
            >
              {data.activate ? "Закрыть" : "Открыть"}
            </button>
          </div>
          <div className={styles.test_content_body}>
            {data.urlgen ? <>
              <input
                type="text"
                value={data.urlgen}
                className={styles.input_url}
                readOnly 
                onClick={(e) => {
                  navigator.clipboard.writeText(e.target.value).then(() => {
                    setNotify({
                      isOpen: true,
                      message: "Ссылка скопирована!",
                      type: "success",
                    }); 
                  }).catch((err) => {
                  });
                }}
              />
            </> : <>
              <button className={styles.open_btn_sub_black} onClick={handleSubmitURL}>
                {t('distance.share_btn')}
              </button>
            </>}


          </div>
          <div className={styles.test_content_body}>
            <p> Прошли: {data.part_worktest ? data?.employee_part_worktest?.filter(item => item.status_info === "Завершен").length || 0 : 0}</p>

            {showUserInfo ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfo(false)}>
              Закрыть
            </button></> : <>
              <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfo(true)}>
                Просмотреть
              </button>
            </>}
          </div>
          <div className={styles.test_content_body}>
            <p> Не завершили: {data.part_worktest ? data?.employee_part_worktest?.filter(item => item.status_info === "Начат").length || 0 : 0}</p>

            {showUserInfoLose ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfoLose(false)}>
              Закрыть
            </button></> : <>
              <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfoLose(true)}>
                Просмотреть
              </button>
            </>}
          </div>
        <div className={styles.test_content_body}>
                  <p> {t('auto.components_testcontent.k1')}</p>
      
                  {showReport ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowReport(false)}>
                    Закрыть
                  </button></> : <>
                    <button className={styles.open_btn_sub_black} onClick={() => handleShowReport(true)}>
                      Просмотреть
                    </button>
                  </>}
                </div>
        </div>


        {showForm ? (
          <TestForm id={id} setRender={setRender} />
        ) : (
          <>
            {showUserInfo ? (
              <TestCaseUser title_dat={data.title} id={id} setRender={setRender} partUserTests={partUserTests} partWorkTests={partWorkTests} />
            ) : showUserInfoLose ? (
              <TestCaseUserLose title_dat={data.title} id={id} setRender={setRender} partUserTests={partUserTestsLose} partWorkTests={partWorkTests} />
            ) : showReport ? (
              <PartWorkReport title_dat={data.title} id={id} setRender={setRender} partWorkTests={partWorkTests} />
            ) : (
              <PartWork id={id} setRender={setRender} partWorkTests={partWorkTests} />
            )}
          </>
          
          
        )}

        <Notification notify={notify} setNotify={setNotify} />
      </div>
    </Layout >
  );
};

export default TestContent;
